// import FieldTripEventEditor from "./fieldTripEventEditor";
import { Button } from "@mui/material";
import TripBookingModal from "./fieldTripEventEditor";
import { useState } from "react";
import TripBookedEvent from "./fieldTripList";
const FieldTripEvent = (props) => {
  const [openCreate, setOpenCreate] = useState(false);

  const handleClose = () => setOpenCreate(false);
  console.log(props.fieldTripBookings);
  return (
    <>
      <TripBookingModal
        open={true}
        handleClose={handleClose}
        reFreshData={props.reFreshData}
      />

      <TripBookedEvent
        fieldTripEvent={props.fieldTripBookings}
        reFreshData={props.reFreshData}
      ></TripBookedEvent>
    </>
  );
};

export default FieldTripEvent;
